import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { TextInput } from 'components/DesignSystem/TextInput';

export const RelatedActivity = ({ isSelected, onFiltersChanged }) => {
    const { control } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <Controller
                render={({ field }) => (
                    <TextInput
                        id={'battlecards-filters-related-activity'}
                        {...field}
                        onChange={(e) => {
                            field.onChange(e.target.value);
                            onFiltersChanged({ [field.name]: e.target.value });
                        }}
                        placeholder={'Related Activity...'}
                        onClear={() => {
                            onFiltersChanged({ [field.name]: '' });
                        }}
                        maxLength={300}
                    />
                )}
                name={`relatedActivity`}
                control={control}
            />
        </div>
    ) : null;
};
